var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.887 0.402599C17.6291 0.144826 17.2794 1.71661e-05 16.9148 1.71661e-05C16.5502 1.71661e-05 16.2006 0.144826 15.9427 0.402599L9.13647 7.20885L2.33022 0.402599C2.0709 0.152132 1.72357 0.0135393 1.36305 0.0166721C1.00253 0.019805 0.65766 0.164412 0.402723 0.419348C0.147787 0.674284 0.00318146 1.01915 4.95911e-05 1.37967C-0.00308418 1.74019 0.135509 2.08752 0.385977 2.34685L8.16435 10.1252C8.4222 10.383 8.77187 10.5278 9.13647 10.5278C9.50107 10.5278 9.85075 10.383 10.1086 10.1252L17.887 2.34685C18.1447 2.089 18.2896 1.73932 18.2896 1.37472C18.2896 1.01012 18.1447 0.660449 17.887 0.402599Z",
    fill: "#4E5258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4fc56b47536509448647b022b40df448.svg";
export { ForwardRef as ReactComponent };